import { AxiosRequestConfig } from 'axios'
import { ROUTES } from 'constants/routesConstants'

import { getApiClient } from '@/api'
import { API_ROUTES, STABLE_ID_COOKIE } from '@/constants'
import { matchPathname } from '@/utils'
import { getCookieClient } from '@/utils/client'

type TCheckoutPage = 'checkout' | 'checkout-plans'

// qr-api reports it as checkout_page on PostHog subscription events
export const getCheckoutPage = (
	pathname: string,
): TCheckoutPage | undefined => {
	if (matchPathname(pathname, ROUTES.checkout.index).match) return 'checkout'
	if (matchPathname(pathname, ROUTES.checkout.plans).match)
		return 'checkout-plans'
	return undefined
}

export const saveCheckoutMetadata = async (): Promise<void> => {
	if (typeof window === 'undefined') return

	// Sent without a stableId too: the checkout page and IP are not Statsig data
	const stableId = getCookieClient(STABLE_ID_COOKIE)
	const checkoutPage = getCheckoutPage(window.location.pathname)

	try {
		await getApiClient().post(
			API_ROUTES.subscription.checkoutMetadata,
			{
				...(stableId && { stableId }),
				...(checkoutPage && { checkoutPage }),
			},
			{ shouldShowErrorNotification: false } as AxiosRequestConfig,
		)
	} catch (error) {
		// Attribution is never worth failing a checkout over.
		console.error('Error saving checkout metadata:', error)
	}
}
